import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { Select } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService, MenuItem } from 'primeng/api';
import { ApiService } from '@core/providers/http';
import {
  ProgramaFormacaoService,
  AreaProgramaFormacaoService,
  AreaFormacaoService,
} from '../../api/services';
import { CadastraProgramaFormacaoComponent } from '../cadastra-programa-formacao/cadastra-programa-formacao.component';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { TableModule } from 'primeng/table';
import { ProgramaFormacao } from '../../api/models/programa-formacao.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import {
  TableComponent,
  TableColumn,
} from '@app/shared/components/table/table.component';
import { FilterItem } from '../../api/models/filterItem.model';
import { Menu } from 'primeng/menu';
import { Pagination } from '@app/shared/model';
import { CoberturaEnumPipe } from '@app/features-modules/gestao-bolseiros/pipes/cobertura.pipe';
import { coberturaEnum } from '../../api/models/coberturaEnum';
import { InputText } from 'primeng/inputtext';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Area } from '../../../../gestao-de-concurso/api/model/area';
import { SelecionarAreasFormacaoComponent } from '../selecionar-areas-formacao/selecionar-areas-formacao.component';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-home-programa-formacao',
  imports: [
    CommonModule,
    PaginatorModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    Select,
    ButtonModule,
    ToastModule,
    SearchBarComponent,
    InputText,
    TableModule,
    Menu,
    TableComponent,
    CoberturaEnumPipe,
    DataVoidComponent,
    SelecionarAreasFormacaoComponent,
    BackButtonComponent,
  ],
  providers: [
    DialogService,
    MessageService,
    ApiService,
    ProgramaFormacaoService,
    AreaProgramaFormacaoService,
    AreaFormacaoService,
  ],
  templateUrl: './home-programa-formacao.component.html',
  styleUrls: ['./home-programa-formacao.component.scss'],
  standalone: true,
})
export class HomeProgramaFormacaoComponent implements OnInit {
  router = inject(Router);
  private auth = inject(AuthStore);
  form!: FormGroup;
  dialogService = inject(DialogService);
  areaProgramaFormacaoService = inject(AreaProgramaFormacaoService);
  areaFormacaoService = inject(AreaFormacaoService);
  programaFormacaoService = inject(ProgramaFormacaoService);
  messageService = inject(MessageService);
  pagination: Pagination<ProgramaFormacao> = new Pagination<ProgramaFormacao>();
  isLoading: boolean = false;
  cities = [];
  areasFormacao: any[] = [];
  programasCount: any;
  areaProgramasFormacao: any[] = [];
  programaSelecionada: ProgramaFormacao | undefined | null;
  constructor(private fb: FormBuilder) {}

  tiposPrograma = [
    { label: 'INTERNA', value: 1 },
    { label: 'EXTERNA', value: 2 },
  ];

  coberturaOption = [
    { id: coberturaEnum.NUMBER_0, designacao: 'Total' },
    { id: coberturaEnum.NUMBER_1, designacao: 'Parcial' },
  ];
  sortFields: any[] = [
    { label: 'Nome', value: 'nome' },
    { label: 'Duração', value: 'duracaoMeses' },
  ];
  filters: FilterItem[] = [
    { type: 'text', controlName: 'Nome', placeholder: 'Pesquise por programa' },
    {
      type: 'dropdown',
      controlName: 'Tipo',
      placeholder: 'Seleccione o tipo',
      options: this.tiposPrograma,
      optionLabel: 'label',
      optionValue: 'value',
    },
  ];
  actions: MenuItem[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      command: ($event: any) => this.editPrograma($event.item.data),
    },
    {
      label: 'Associar áreas de formação',
      icon: 'pi pi-plus',
      command: ($event: any) => this.abrirModalAreasFormacao($event.item.data),
    },
    {
      label: 'Excluir',
      icon: 'pi pi-trash',
      command: ($event: any) => this.StatusProgramaFormacao($event.item.data),
    },
  ];
  columns: TableColumn[] = [
    { field: 'nome', header: 'Nome do Programa' },
    {
      field: 'duracaoMeses',
      header: 'Duração (meses)',
      tooltip: 'Total de meses',
    },
    // { field: 'modulo', header: 'Nº de módulos' },
    { field: 'tipo', header: 'Tipo' },
    { field: 'coberturaDescricao', header: 'Cobertura' },
    { field: 'dataInicio', header: 'Data de início' },
    { field: 'dataFim', header: 'Data de fim' },
  ];
  @ViewChild('menu') menu!: Menu;

  selectedPrograma: any | null = null;

  ngOnInit() {
    this.loadProgramas();
    this.loadAllAreaFormacao();
    this.form = this.fb.group({
      Nome: [null],
      Tipo: [null],
    });
  }

  loadAllAreaFormacao() {
    this.areaFormacaoService
      .list({
        pageNumber: 1,
        pageSize: 1000,
        OrderBy: 'id desc',
      })
      .subscribe((res: any) => {
        this.areasFormacao = res;
      });
  }

  loadProgramas(filters?: any) {
    this.isLoading = true; // Iniciar carregamento
    const params = {
      ...filters,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: filters?.orderBy || 'id desc',
    };
    this.programaFormacaoService.list(params).subscribe(
      (res: any) => {
        this.pagination = new Pagination<ProgramaFormacao>().deserialize(res);
        this.programasCount = this.pagination?.totalRecords;
        this.isLoading = false; // Parar carregamento
      },
      (error: any) => {
        console.error('Erro ao buscar programas de formação:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar programas de formação.',
        });
        this.isLoading = false; // Parar carregamento
      },
    );
  }

  areaProgramaFormacaoByProgramaId(id: any) {
    this.areaProgramaFormacaoService
      .list({ pageNumber: 1, pageSize: 1000, ProgramaFormacaoId: id })
      .subscribe((res: any) => {
        this.areaProgramasFormacao = res.data;
      });
  }

  showDialog() {
    if (this.auth.hasAny(['registar_acordo_formação'])) {
      const ref = this.dialogService.open(CadastraProgramaFormacaoComponent, {
        showHeader: false,
        width: '55%',
        modal: true,
      });

      ref.onClose.subscribe((data) => {
        if (data) {
          this.isLoading = true; // Iniciar carregamento
          this.programaFormacaoService.store(data).subscribe((response) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Acordo de Formação adicionado com sucesso',
            });
            this.loadProgramas(); // Recarregar os programas após adicionar
          });
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadProgramas();
  }

  editPrograma(selectedPrograma: any) {
    if (this.auth.hasAny(['actualizar_acordo_formação'])) {
      this.selectedPrograma = selectedPrograma;

      if (!this.selectedPrograma) return;

      const ref = this.dialogService.open(CadastraProgramaFormacaoComponent, {
        showHeader: false,
        width: '55%',
        modal: true,
        data: this.selectedPrograma,
      });

      ref.onClose.subscribe((data) => {
        if (data) {
          this.isLoading = true;
          this.programaFormacaoService
            .update(data, this.selectedPrograma.id)
            .subscribe((response) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Acordo de Formação actualizado com sucesso',
              });
              this.loadProgramas();
            });
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  // Adicionar no método showDialog para abrir a modal
  abrirModalAreasFormacao(programa: ProgramaFormacao) {
    this.areaProgramaFormacaoService
      .list({ pageNumber: 1, pageSize: 1000, ProgramaFormacaoId: programa.id })
      .subscribe((res: any) => {
        this.areaProgramasFormacao = res.data;
        const ref = this.dialogService.open(SelecionarAreasFormacaoComponent, {
          header: 'Selecionar Áreas de Formação',
          width: '50%',
          showHeader: false,
          modal: true,
          data: {
            areasFormacao: this.areasFormacao,
            selectedAreas: this.areaProgramasFormacao.map(
              (area) => area.areaFormacao.id,
            ), // IDs já associados
          },
        });

        ref.onClose.subscribe((selectedAreas) => {
          if (selectedAreas) {
            this.associarAreasAoPrograma(selectedAreas, programa);
          }
        });
      });
  }

  associarAreasAoPrograma(selectedAreas: any[], programa: ProgramaFormacao) {
    // const data = selectedAreas.map((id) => ({
    //   programaFormacaoId: programa.id,
    //   areaFormacaoId: id,
    // }));
    const data = {
      id: 0,
      programaFormacaoId: programa.id,
      areaFormacaoId: selectedAreas, // A lista de IDs é passada aqui
    };

    this.areaProgramaFormacaoService
      .addAreaProgramaFormacaoArray(data)
      .subscribe(
        () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Áreas associadas com sucesso.',
          });
        },
        (error: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao associar áreas ao programa.',
          });
          console.error(error);
        },
      );
  }

  deletePrograma(selectedPrograma: any) {
    this.selectedPrograma = selectedPrograma;
    console.log('selectedPrograma:', this.selectedPrograma);

    if (!this.selectedPrograma) return;

    this.isLoading = true;

    this.programaFormacaoService.delete(this.selectedPrograma.id).subscribe(
      () => {
        console.log('Id do programa excluído:', this.selectedPrograma.id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Acordo de Formação excluído com sucesso',
        });
        this.loadProgramas();
        this.isLoading = false;
      },
      (error: any) => {
        console.error('Erro ao excluir programa de formação:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao excluir programa de formação.',
        });
        this.isLoading = false;
      },
    );
  }

  StatusProgramaFormacao(selectedPrograma: any) {
    this.selectedPrograma = selectedPrograma;
    console.log('selectedPrograma:', this.selectedPrograma);
    if (!this.selectedPrograma) return;
    this.isLoading = true;
    this.programaFormacaoService
      .toggleStatus(this.selectedPrograma.id)
      .subscribe(
        () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Acordo de Formação excluído com sucesso',
          });
          this.loadProgramas();
          this.isLoading = false;
        },
        (error: any) => {
          console.error('Erro ao excluir programa de formação:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao excluir programa de formação.',
          });
          this.isLoading = false;
        },
      );
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    this.loadProgramas(filters);
    this.showFilter = false;
  }
}
